import React from 'react'
import { Map } from 'immutable'
import { Widget, Action, AsyncState, Option, none, any, wait, onlyIf, loadingAsyncState, async, some } from 'widgets-for-react'
import { mapLanguage } from '../../../../helpers'
import { fromJSX, SimpelPage, visit_option } from '../../../../utils'
import { getParameterByName, insertUrlParam, removeUrlParams } from '../../../cms/blocks/utils.gen'
import { TemplateState } from '../../../cms/page/types.gen'
import { get_lang_from_url } from '../../../map/maps_utils'
import { CustomBlock } from '../../../wordpress/types_and_parser/custom_blocks.mod'
import { Block } from '../../../wordpress/types_and_parser/standard_blocks.gen'
import { PublicSite_CustomPageData } from '../../application.mod'
import { CustomBlockData } from '../../blocks/custom_blocks/types.mod'
import { ExtraImages } from '../../utils/extra_images.mod'
import { get_paginated_webinars, get_taxonomies } from './webinars.api'
import { WebinarsOverviewLayout } from './webinars.layout'
import { Webinar, TaxonomyResponse } from './webinars.types'

export interface WebinarsOverviewState {
  webinars: Map<number, AsyncState<SimpelPage<Webinar>>>
  total_pages: Option<number>
  size: number
  current_page: number
  topicTaxonomy: AsyncState<TaxonomyResponse[]>
  countryTaxonomy: AsyncState<TaxonomyResponse[]>
  pagination_page: number
  pagination_size: number
  current_filters: FilterState
}

type FilterState = {
  term: Option<number>
  country: Option<number | string>
}

export const UpdateFilter = (filter: FilterState, filter_key: keyof FilterState, value: any): FilterState => ({ ...filter, [filter_key]: value })

export const zeroWebinarsOverviewState: WebinarsOverviewState = {
  size: 12,
  webinars: Map(),
  total_pages: none(),
  current_page: 1,
  topicTaxonomy: loadingAsyncState(() => get_taxonomies('brochures_taxonomy', mapLanguage(get_lang_from_url(_ => "")))),
  countryTaxonomy: loadingAsyncState(() => get_taxonomies('country_taxonomy', mapLanguage(get_lang_from_url(_ => "")))),
  pagination_page: 1,
  pagination_size: 12,
  current_filters: {
    term: none(),
    country: none()
  }
}

export const WebinarsOverviewWidget: (s0: TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>) => Widget<Action<WebinarsOverviewState>> =
  (s0: TemplateState<CustomBlockData, CustomBlock, Block, ExtraImages, PublicSite_CustomPageData>) =>
    any<Action<WebinarsOverviewState>>()([

      onlyIf(s0.webinarsOverview.total_pages.v.kind == 'l' || s0.webinarsOverview.webinars.count() < s0.webinarsOverview.total_pages.v.v,
        wait<Action<WebinarsOverviewState>>(500)(() => s1 => {
          let has_next = s1.total_pages.v.kind == 'l' || (s1.webinars.count() < s1.total_pages.v.v)
          if (!has_next) return s1

          let termFilter = s1.current_filters.term
          let term = getParameterByName('term')
          if (term != '' && !isNaN(Number(term))) {
            termFilter = some(Number(term))
          }

          let countryFilter = s1.current_filters.country
          let country = getParameterByName('country')
          if (country != '' && !isNaN(Number(country))) {
            countryFilter = some(Number(country))
          }

          // let page = s1.pagination_page
          // let page_param = getParameterByName('page')
          // if (page_param != '' && !isNaN(Number(page_param))) {
          //   page = Number(page_param)
          // }

          return ({
            ...s1,
            current_filters: {
              ...s1.current_filters,
              term: termFilter,
              country: countryFilter

            },
            // pagination_page: page,
            webinars: s1.webinars.set(s1.current_page, loadingAsyncState(() => get_paginated_webinars(mapLanguage(get_lang_from_url(_ => "")),
              { // query params
                page: s1.current_page,
                per_page: s1.size,
                _embed: 1,
                brochures_taxonomy: visit_option<number, number | undefined>(termFilter)(v => v, () => undefined),
                country_taxonomy: visit_option<number | string, number | string | undefined>(countryFilter)(v => v, () => undefined)
              }
            ))
            ),
          })
        })
      ),

      any<Action<Map<number, AsyncState<SimpelPage<Webinar>>>>>()(
        s0.webinarsOverview.webinars.keySeq().map(k =>
          async<SimpelPage<Webinar>>()(s0.webinarsOverview.webinars.get(k)).map(a => (s: Map<number, AsyncState<SimpelPage<Webinar>>>) => s.set(k, a(s.get(k))))
        )
          .toArray()
      ).map(a => s1 => {
        let newData = a(s1.webinars)
        let first_entry = newData.get(1)
        return ({
          ...s1,
          webinars: newData,
          total_pages: first_entry != null && first_entry.kind == 'loaded' ? some(first_entry.value.total_pages) : none(),
          current_page: first_entry != null && first_entry.kind == 'loaded' ? s1.current_page + 1 : s1.current_page
        })
      }),

      async<TaxonomyResponse[]>()(s0.webinarsOverview.topicTaxonomy).map(a => s => ({ ...s, topicTaxonomy: a(s.topicTaxonomy) })),
      async<TaxonomyResponse[]>()(s0.webinarsOverview.countryTaxonomy).map(a => s => ({ ...s, countryTaxonomy: a(s.countryTaxonomy) })),

      fromJSX(setState => <WebinarsOverviewLayout data={s0.webinarsOverview}
        onPropChange={(prop, value) => setState(s => {
          if (prop == 'current_filters') {
            // Start filtering on change
            visit_option((value as FilterState).term)(v => insertUrlParam('term', v.toString()), () => removeUrlParams('term'))
            visit_option((value as FilterState).country)(v => insertUrlParam('country', v.toString()), () => removeUrlParams('country'))

            return ({ ...s, [prop]: value, current_page: 1, pagination_page: 1, total_pages: none(), webinars: Map() })
          }
          return ({ ...s, [prop]: value })
        })}
      />)
    ])


